import { useEffect, useState } from "react";
import { IRestaurantDetail, RestaurantList } from "../models/IRestaurantDetail";
import { getRestaurantById, getRestaurantList, deleteRestaurant } from "../services/restaurant";
import AddRestaurantPage from "./AddRestaurantPage";
import EditRestaurantDeliveryAddress from "../components/EditRestaurantsDeliveryAddress";
import MyFoods from "../components/MyFoods";
import UploadRestaurantLogoModal from "../components/UploadRestaurantLogoModal";
import UploadRestaurantFeaturedImageModal from "../components/UploadRestaurantFeaturedImageModal";

type TabId = 'pills-home' | 'pills-profile' | 'pills-adress';

const TABS: { id: TabId; label: string; icon: string }[] = [
  { id: 'pills-home',    label: 'Menu',              icon: 'bi-grid'          },
  { id: 'pills-profile', label: 'Detay',             icon: 'bi-pencil-square' },
  { id: 'pills-adress',  label: 'Siparis Adresleri', icon: 'bi-geo-alt'       },
];

function RestaurantsPage() {
  const [selectedRestaurant, setSelectedRestaurant] = useState<IRestaurantDetail>();
  const [restaurantList, setrestaurantList] = useState<RestaurantList>();
  const [selectedRestaurantId, setSelectedRestaurantId] = useState<string>();
  const [activeTab, setActiveTab] = useState<TabId>('pills-home');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleting, setDeleting] = useState(false);
  const [showLogoModal, setShowLogoModal] = useState(false);
  const [showFeaturedModal, setShowFeaturedModal] = useState(false);

  const handleDeleteRestaurant = async () => {
    if (!selectedRestaurantId) return;
    setDeleting(true);
    try {
      await deleteRestaurant(selectedRestaurantId);
      setShowDeleteConfirm(false);
      setSelectedRestaurant(undefined);
      setSelectedRestaurantId(undefined);
      const res = await getRestaurantList();
      if (res.data) setrestaurantList(res.data);
    } catch {
    } finally {
      setDeleting(false);
    }
  };

  useEffect(() => {
    getRestaurantList().then((response) => {
      if (response.data) setrestaurantList(response.data);
    });
  }, []);

  const refreshRestaurant = (id?: string) => {
    const targetId = id ?? selectedRestaurantId;
    if (targetId) {
      getRestaurantById(targetId).then((res) => {
        if (res.data) setSelectedRestaurant(res.data);
      });
    }
  };

  useEffect(() => {
    refreshRestaurant(selectedRestaurantId);
  }, [selectedRestaurantId]);

  return (
    <div className="container py-4" style={{ maxWidth: '1200px' }}>

      {/* ── Üst alan: select + restoran kartı ── */}
      <div className="row align-items-center mb-4 g-3">

        {/* Restoran seçici */}
        <div className="col-md-5">
          <label
            className="form-label text-muted small fw-semibold mb-1 text-uppercase"
            style={{ letterSpacing: '0.05em' }}
          >
            <i className="bi bi-building me-1"></i>Restoran
          </label>
          <select
            className="form-select form-select-lg"
            style={{
              borderRadius: '12px',
              border: '1.5px solid #dee2e6',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
              fontWeight: 500,
            }}
            value={selectedRestaurantId ?? ""}
            onChange={(evt) => setSelectedRestaurantId(evt.target.value)}
          >
            <option value="" disabled>Restoran seçiniz...</option>
            {restaurantList?.items.map((item) => (
              <option key={item.id} value={item.id}>{item.restourantName}</option>
            ))}
          </select>
        </div>

        {/* Restoran özet kartı */}
        {selectedRestaurant && (
          <div className="col-md-7">
            <div
              className="p-3 rounded-3"
              style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                border: '1.5px solid #e9ecef',
                boxShadow: '0 4px 16px rgba(0,0,0,0.07)',
              }}
            >
              <div className="d-flex align-items-center">
                <div className="url-logo-wrap" onClick={() => setShowLogoModal(true)} title="Logoyu güncelle">
                  <img
                    src={"https://mutfacik.s3.eu-central-1.amazonaws.com/" + selectedRestaurant.restourantLogoPath}
                    className="url-logo-img"
                    alt={selectedRestaurant.restourantName}
                  />
                  <div className="url-logo-edit-overlay">
                    <i className="bi bi-pencil-fill"></i>
                  </div>
                </div>
                <div className="ms-3 flex-grow-1">
                  <h5 className="mb-1 fw-bold" style={{ fontSize: '1.1rem' }}>
                    {selectedRestaurant.restourantName}
                  </h5>
                  <div className="d-flex gap-2 flex-wrap mt-1 align-items-center">
                    <span
                      className="badge"
                      style={{ background: '#d1fae5', color: '#065f46', fontSize: '0.72rem', borderRadius: '20px', padding: '4px 10px' }}
                    >
                      <i className="bi bi-check-circle-fill me-1"></i>Secili Restoran
                    </span>
                    {selectedRestaurant.restourantIsEnabled ? (
                      <span
                        className="badge"
                        style={{ background: '#dcfce7', color: '#166534', fontSize: '0.72rem', borderRadius: '20px', padding: '4px 10px' }}
                      >
                        <i className="bi bi-door-open-fill me-1"></i>Acik
                      </span>
                    ) : (
                      <span
                        className="badge"
                        style={{ background: '#fee2e2', color: '#991b1b', fontSize: '0.72rem', borderRadius: '20px', padding: '4px 10px' }}
                      >
                        <i className="bi bi-door-closed-fill me-1"></i>Kapali
                      </span>
                    )}
                    <button
                      onClick={() => setShowDeleteConfirm(true)}
                      style={{
                        marginLeft: 'auto', display: 'inline-flex', alignItems: 'center', gap: '5px',
                        background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca',
                        borderRadius: '20px', padding: '4px 12px', fontSize: '0.72rem', fontWeight: 700,
                        cursor: 'pointer',
                      }}
                    >
                      <i className="bi bi-trash3-fill"></i>Restoranı Sil
                    </button>
                  </div>
                </div>
              </div>

              {/* Öne çıkan görsel */}
              <div
                className="url-featured-wrap"
                onClick={() => setShowFeaturedModal(true)}
                title="Öne çıkan görseli güncelle"
              >
                {selectedRestaurant.restourantFeatureadImagePath ? (
                  <img
                    src={"https://mutfacik.s3.eu-central-1.amazonaws.com/" + selectedRestaurant.restourantFeatureadImagePath}
                    className="url-featured-img"
                    alt="öne çıkan görsel"
                  />
                ) : (
                  <div className="url-featured-empty">
                    <i className="bi bi-card-image"></i>
                    <span>Öne Çıkan Görsel Ekle</span>
                  </div>
                )}
                <div className="url-logo-edit-overlay">
                  <i className="bi bi-pencil-fill"></i>
                </div>
              </div>

            </div>
          </div>
        )}
      </div>

      {/* ── Sekme navigasyonu ── */}
      <div
        className="d-inline-flex gap-1 mb-4 p-1 rounded-3"
        style={{ background: '#f1f3f5' }}
      >
        {TABS.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              style={{
                borderRadius: '10px',
                padding: '8px 18px',
                fontWeight: 600,
                fontSize: '0.88rem',
                color: isActive ? '#212529' : '#6c757d',
                background: isActive ? '#ffffff' : 'transparent',
                border: isActive ? '1px solid #e0e0e0' : '1px solid transparent',
                boxShadow: isActive ? '0 1px 4px rgba(0,0,0,0.1)' : 'none',
                transition: 'all 0.2s',
                cursor: 'pointer',
              }}
            >
              <i className={`bi ${tab.icon} me-1`}></i>{tab.label}
            </button>
          );
        })}
      </div>

      {/* ── Silme onay modalı ── */}
      {showDeleteConfirm && (
        <div style={{
          position: 'fixed', inset: 0, zIndex: 1050,
          background: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(4px)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <div style={{
            background: '#fff', borderRadius: '18px', padding: '32px 28px',
            width: '100%', maxWidth: '400px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
            textAlign: 'center',
          }}>
            <div style={{
              width: '56px', height: '56px', borderRadius: '50%',
              background: '#fef2f2', display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 16px',
            }}>
              <i className="bi bi-trash3-fill" style={{ fontSize: '1.5rem', color: '#dc2626' }}></i>
            </div>
            <h5 style={{ fontWeight: 800, marginBottom: '8px' }}>Restoranı Sil</h5>
            <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '8px' }}>
              <strong style={{ color: '#111827' }}>{selectedRestaurant?.restourantName}</strong> adlı restoranı silmek istediğinize emin misiniz?
            </p>
            <p style={{ color: '#dc2626', fontSize: '0.8rem', marginBottom: '24px' }}>Bu işlem geri alınamaz.</p>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button
                onClick={() => setShowDeleteConfirm(false)}
                disabled={deleting}
                style={{
                  flex: 1, padding: '11px', borderRadius: '10px',
                  border: '1.5px solid #e5e7eb', background: '#fff',
                  fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', color: '#374151',
                }}
              >
                İptal
              </button>
              <button
                onClick={handleDeleteRestaurant}
                disabled={deleting}
                style={{
                  flex: 1, padding: '11px', borderRadius: '10px',
                  border: 'none', background: '#dc2626',
                  fontWeight: 700, fontSize: '0.9rem', cursor: 'pointer', color: '#fff',
                  opacity: deleting ? 0.7 : 1,
                }}
              >
                {deleting ? <span className="spinner-border spinner-border-sm me-2" /> : null}
                Evet, Sil
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Logo upload modal ── */}
      {selectedRestaurant?.id && (
        <UploadRestaurantLogoModal
          isOpen={showLogoModal}
          onClose={() => setShowLogoModal(false)}
          onSaved={() => refreshRestaurant()}
          restaurantId={selectedRestaurant.id}
          restaurantName={selectedRestaurant.restourantName}
        />
      )}

      {/* ── Featured image upload modal ── */}
      {selectedRestaurant?.id && (
        <UploadRestaurantFeaturedImageModal
          isOpen={showFeaturedModal}
          onClose={() => setShowFeaturedModal(false)}
          onSaved={() => refreshRestaurant()}
          restaurantId={selectedRestaurant.id}
          restaurantName={selectedRestaurant.restourantName}
        />
      )}

      {/* ── İçerik ── */}
      <div>
        {activeTab === 'pills-home' && (
          <MyFoods
            selectedRestaurantId={selectedRestaurant?.id}
            onSelectFood={() => {}}
          />
        )}
        {activeTab === 'pills-profile' && (
          <AddRestaurantPage props={selectedRestaurant} isUpdate={true} onSaved={() => refreshRestaurant()} />
        )}
        {activeTab === 'pills-adress' && (
          <EditRestaurantDeliveryAddress restaurant={selectedRestaurant} />
        )}
      </div>
    </div>
  );
}

export default RestaurantsPage;